import { Outlet } from 'react-router-dom';
import { Sidebar } from '@/components/sidebar/Sidebar';
import { MobileSidebarDrawer } from '@/components/sidebar/MobileSidebarDrawer';
import { UserMenuButton } from '@/components/chat/UserMenuButton';
import { PlanRedirect } from '@/components/routing/PlanRedirect';
import { DeadlineToastNotifier } from '@/components/notifications/DeadlineToastNotifier';
import { GenerationReadyNotifier } from '@/components/notifications/GenerationReadyNotifier';
import { GlobalGenerationManager } from '@/components/oposiciones/GlobalGenerationManager';

export function AppLayout() {
  return (
    <div className="flex h-screen bg-background">
      <PlanRedirect />
      <DeadlineToastNotifier />
      <GenerationReadyNotifier />
      <GlobalGenerationManager />

      {/* Desktop sidebar */}
      <div className="hidden md:flex">
        <Sidebar />
      </div>

      <main className="flex-1 flex flex-col overflow-hidden min-w-0">
        {/* Mobile top bar with hamburger */}
        <div className="md:hidden flex items-center justify-between gap-3 border-b border-border bg-card px-2 py-2 shrink-0">
          <div className="flex items-center gap-2 min-w-0">
            <MobileSidebarDrawer variant="funcionarios" triggerClassName="" />
            <span className="text-sm font-semibold text-[#002B5B] truncate">Munilex</span>
          </div>
          <UserMenuButton variant="funcionarios" />
        </div>

        <div className="flex-1 flex flex-col overflow-hidden">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
